module.exports = __webpack_public_path__ + "static/media/track-bottom.21648072.png";